
let backendAPI = 'https://apidientu.goldenhealthcarevn.com:4000';
export default backendAPI;
